import { useQuery } from '@tanstack/react-query';
import type { UseQueryResult } from '@tanstack/react-query';
import { QueryKey } from '../utils/api';
import { sfccGet } from '../utils/sitegenesis';
import { isServer } from '../utils/utils';
import type { UserAddress } from './model/UserAddress';

export const useCustomerGeoLocation = (): UseQueryResult<UserAddress, unknown> =>
    useQuery<unknown, unknown, UserAddress>({
        queryFn: () => sfccGet<UserAddress>('GoLocal-IpLocation'),
        queryKey: [QueryKey.CUSTOMER_GEO_LOCATION],
        keepPreviousData: true,
        enabled: !isServer,
        staleTime: Infinity,
    });
